import styled from '@emotion/styled';
import { GridItemProps } from './GridItem';

export const StyledGridItem = styled.section<GridItemProps>(({ area }) => ({
    gridArea: area,
}));
